import { render, staticRenderFns } from "./ClickVerification.vue?vue&type=template&id=e6b7cc4a&scoped=true"
import script from "./ClickVerification.vue?vue&type=script&lang=js"
export * from "./ClickVerification.vue?vue&type=script&lang=js"
import style0 from "./ClickVerification.vue?vue&type=style&index=0&id=e6b7cc4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b7cc4a",
  null
  
)

export default component.exports